<template>
    <section class="WheelNavigationTiny ContentSection">
        <h4 v-html="properties.title"></h4>
        <div v-html="properties.subtitle"></div>

        
        <article class="WheelNavigationTiny__linkwrapper">
            <div>
                <transition-group :name="animations[direction].name">
                    <router-link v-for="(link, i) in properties.links" :key="link.title" :to="getRouteFromID(link.sceneLink)" v-show="activeLink === i" v-html="link.title"></router-link>
                </transition-group>
            </div>
        </article>

        <article class="WheelNavigationTiny__wheelwrapper">
            <button class="WheelNavigationTiny__wheelwrapper__button WheelNavigationTiny__wheelwrapper__button--prev" @click="linkPrev"></button>
            <button class="WheelNavigationTiny__wheelwrapper__button WheelNavigationTiny__wheelwrapper__button--next" @click="linkNext"></button>
            <div id="WheelNavigationTiny__wheel" :class="{'WheelNavigationTiny__wheel--idle': isIdle}">
                <img src="@/assets/img/ui/tiny-wheel-navigation.svg" :style="wheelRotation">
            </div>
        </article>
    </section>
</template>
<script>
export default {
    props: ["properties", "pageData"],
    data() {
        return {
            activeLink: 0,
            direction: "left",
            rotationTracker: 0,
            
            isIdle: true,
            idleTimer: null,

            animations: {
                left: {
                    name: "fadeOutLeft"
                },
                right: {
                    name: "fadeOutRight"
                }
            }
        }
    },
    mounted() {
        this.initHammer();
        this.activeLink = this.getRandomStart();
    },
    methods: {
        initHammer() {
            var element = document.getElementById("WheelNavigationTiny__wheel");
            var mc = new Hammer(element);
            var t = this;

            mc.on("swipeleft swiperight", function (ev) {
                switch (ev.type) {
                default:
                    if (ev.type == "swipeleft") {
                        t.linkPrev();
                    } else if (ev.type == "swiperight") {
                        t.linkNext();
                    }
                    break;
                }
            });
        },
        linkPrev() {
            this.rotationTracker--;
            if(this.activeLink !== 0) {
                this.activeLink--;
            } else {
                this.activeLink = this.properties.links.length - 1;
            }
            this.direction = "left"
        },
        linkNext() {
            this.rotationTracker++;
            if(this.activeLink < this.properties.links.length - 1) {
                this.activeLink++;
            } else {
                this.activeLink = 0;
            }
            this.direction = "right"
        },
        getRandomStart() {
            let length = this.properties.links.length - 1;

            return Math.floor(Math.random() * length);
        },
        
        getRouteFromID(id) {
            return app.manifest.getRouteFromID(id);
        }
    },
    watch: {
        rotationTracker() {
            this.isIdle = false;
            clearTimeout(this.idleTimer);
            this.idleTimer = setTimeout(() => {
                this.isIdle = true;
            }, 1000);
        }
    },
    computed: {
        wheelRotation() {
            let rotation = 30 * this.rotationTracker; 
            return {
                transform: `translateX(-50%) translateY(-50%) rotate(${rotation}deg)`
            }
        }
    }
}
</script>
<style lang="scss">
    @import '@/assets/sass/_responsiveness.scss';
    .WheelNavigationTiny {
        display: flex;
        align-items: center;
        flex-direction: column;
        text-align: left;
        padding: 100px 0 0 0;
        background: var(--light-grey);

        h4 {
            margin-bottom: 20px;    
        }

        &>div {
            display: flex;
            align-items: center;
            flex-direction: column;
            width: 100%;
            margin-bottom: 40px;
        }

        &>article {
            width: 100%;
            max-width: var(--content-max-width);
            padding: var(--content-padding);
        }
        
        .WheelNavigationTiny__linkwrapper {
            &> div{
                position: relative;
                background: #fff;
                height: 75px;
                border-radius: 29px;
                overflow: hidden;
                padding-left: 40px;box-shadow: var(--shadow-medium);

                &>a {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    font-size: 20px;

                    p> {
                        padding: 0;
                    }
                }

                &::after {
                    content: '';
                    position: absolute;
                    height: 28px;
                    width: 15px;
                    right: 35px;
                    top: 50%;
                    transform: translateY(-50%);
                    background-image: url(@/assets/img/ui/btn-arrow.svg);
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 100%;
                    transition: var(--tk-easeinout) 0.2s transform;
                }

                &:hover {
                    &::after {
                        transform: translateY(-50%) translateX(5px);
                    }
                }
            }
        }
        

        .WheelNavigationTiny__wheelwrapper {
            position: relative;
            .WheelNavigationTiny__wheelwrapper__button {
                position: absolute;
                top: 200px;
                transform: translateY(-50%);
                width: 60px;
                height: 60px;
                cursor: pointer;
                border-radius: 1000px;
                background-image: url(@/assets/img/ui/btn-next.svg);
                background-position: center;
                background-repeat: no-repeat;
                transform-origin: 50% 0;
                transition: var(--tk-easeinout) 0.1s transform;

                &.WheelNavigationTiny__wheelwrapper__button--prev {
                    right: calc(100% + 60px);
                    rotate: 180deg;
                }

                &.WheelNavigationTiny__wheelwrapper__button--next {
                    left: calc(100% + 60px);
                }

                &.WheelNavigationTiny__wheelwrapper__button--inactive {
                    background-image: url(@/assets/img/ui/btn-next-outline.svg);
                }

                &:hover {
                    transform: scale(1.05) translateY(-50%);
                }
            }   

            #WheelNavigationTiny__wheel {
                position: relative;
                overflow: hidden;
                width: 100%;
                aspect-ratio: 1 / 0.55;

                *{ 
                    pointer-events: none;
                }

                &>img {
                    position: relative;
                    width: calc(100% - 40px);
                    transform: translateX(-50%) translateY(-50%);
                    left: 50%;
                    top: 100%;
                    transition: var(--tk-easeinout) 0.15s transform;
                }
                
                &::before {
                    content: '';
                    position: absolute;
                    top: 18%;
                    left: 50%;
                    transform: translateX(-50%) translateY(0);
                    width: 104px;
                    height: 46px;
                    background-image: url(@/assets/img/ui/tiny-wheel-navigation-arrow.svg);
                    background-size: 100%;
                    transition: var(--tk-easeinout) 0.3s transform;
                }
                
                &::after {
                    content: "";
                    position: absolute;
                    left: 50%;
                    bottom: 0;
                    transform: translateX(-50%);
                    width: 150px;
                    height: 75px;
                    background-image: url(@/assets/img/ui/drag-drop-icon.svg);
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 100%;
                    z-index: 2;
                    pointer-events: none;
                }
                
                &.WheelNavigationTiny__wheel--idle {
                    &::before {
                        transform: translateX(-50%) translateY(-40px);
                    }
                }
            }
        }

        @include mobile-only {
            .WheelNavigationTiny__linkwrapper {
                > div {
                    &::after {
                        height: 23px;
                        width: 12px;
                        right: 20px;
                    }
                }
            } 

            .WheelNavigationTiny__wheelwrapper {
                #WheelNavigationTiny__wheel {
                    //ios: safari 14 doesn't do aspect-ratio
                    height: 50vw;
                    aspect-ratio: initial;

                    &::before {
                        top: 80px;
                        width: 52px;
                        height: 23px;
                    }
                    &::after {
                        width: 100px;
                        height: 50px;
                    }
                }
            }
        }
        @include tablet-down {
            .WheelNavigationTiny__wheelwrapper {
                .WheelNavigationTiny__wheelwrapper__button {
                    display: none;
                }
            }
        }
    }
</style>